goog.provide('el8.practicedata.facilityIdentifiers');

goog.require('el8.model.base');
goog.require('el8.service.urls');
goog.require('el8.util.string');

el8.practicedata.facilityIdentifiers = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeDeleteable();

    _class.addIntProperty('vendorId', true);
    _class.addStringProperty('vendorName', true);
    _class.addStringProperty('description', true);
    _class.addStringProperty('practiceFacility', true);
    _class.addStringProperty('practiceSecondaryId', true);
    _class.addStringProperty('labFacility', true);
    _class.addIntProperty('compendiumId', true);

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        this.parent.populate.call(this, spec);
    };

    _class.prototype.asSoyMap = function() {
        var soyMap = this.parent.asSoyMap.call(this);
        var displayName = this.getDescription();
        // Use practice secondary id if we have it, else practice facility
        if (!displayName) {
            displayName = this.getVendorName() + ' - ' + this.getPracticeFacility();
        }
        soyMap.displayName = displayName;
        return soyMap;
    };

    var that =  new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        sortFn: function(a, b) {
            return el8.util.string.cmp(a.getVendorName(), b.getVendorName());
        },
        urlLoad: function() { return el8.service.urls.get('userFacingFacilityIds'); },
        urlFn: function(id) { return el8.service.urls.get('userFacingFacilityIds'); }
    });

    return that;

})();
